module.exports = __webpack_public_path__ + "static/media/hualian_pic4.8be05f5d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian_pic4.jpg
 ** module id = 447
 ** module chunks = 0
 **/